import './TWCPager.web.css';

import React, { forwardRef } from 'react';
import Slider from 'react-slick';

import { TWCPagerProps } from './types';

export const TWCPager = forwardRef<Slider, TWCPagerProps>((props, reference) => {
  const { initialIndex = 0, onIndexChanged, autoplay = false, children } = props;

  return (
    <Slider
      afterChange={onIndexChanged}
      arrows={false}
      autoplay={autoplay}
      dots={false}
      infinite={false}
      initialSlide={initialIndex}
      pauseOnFocus={false}
      pauseOnHover={false}
      ref={reference}
      rows={1}
      slidesToScroll={1}
      slidesToShow={1}
      vertical={false}
    >
      {children}
    </Slider>
  );
});
